module.exports = __webpack_public_path__ + "static/media/3.cfa78ef6.png";